"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const material_1 = require("@mui/material");
const ListItemIcon_1 = tslib_1.__importDefault(require("@mui/material/ListItemIcon"));
const MneListItemIcon = (0, material_1.styled)(ListItemIcon_1.default)(() => ({
    color: "inherit",
    minWidth: "20px",
}));
exports.default = MneListItemIcon;
